import data from 'data/songs.json';

export const getSongs = async () => {
  const { songs } = data;
  return songs;
};
